import styled, { css } from 'styled-components';
import Icon from '../../elements/Icon';
import Link from 'next/link';

export const PaginationWrapper = styled.div`
    ${({ theme }) => css`
        display: inline-block;
        max-width: 100%;
        padding: 0.4rem;
        border-radius: 0.5rem;
        border: ${theme.commonStyles.brandPixel} solid ${theme.colors.secondary.tints[0].hex};

        @media ${theme.breakpoints.medium.media} {
            padding: 0.8rem;
        }
    `}
`;

export const PageLinksWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

const pageNumber = ({ theme }) => css`
    padding: 0.4rem;
    margin: 0;
    font-size: 1.125rem;
    line-height: 1.2;
    font-weight: 400;
    color: ${theme.colors.tertiary.hex};
    background: transparent;
    border: none;
    border-radius: 0.5rem;

    @media ${theme.breakpoints.medium.media} {
        padding: 0.5rem 0.9rem;
    }
`;

export const StyledLink = styled(Link)`
    ${({ theme }) => css`
        ${pageNumber}
        text-decoration: none;

        @media (hover: hover) {
            &:hover {
                background: ${theme.colors.primary.hex};
                color: ${theme.colors.primaryContrast.hex};
                cursor: pointer;
            }
        }
    `}
`;

export const StyledLinkIcon = styled(StyledLink)`
    display: flex;
    align-items: center;

    &:first-of-type {
        margin-right: 1.25rem;
    }

    &:last-of-type {
        margin-left: 1.25rem;
    }
`;

export const CurrentPageLink = styled.span`
    ${({ theme }) => css`
        ${pageNumber}
        color: ${theme.colors.primary.hex};
    `}
`;

export const Ellipsis = styled.span`
    ${({ theme }) => css`
        color: ${theme.colors.secondary.tints[1].hex};
        margin: 0 0.25rem;

        @media ${theme.breakpoints.medium.media} {
            margin: 0 0.5rem;
        }
    `}
`;

export const StyledIcon = styled(Icon)<{ $prev?: boolean }>`
    ${({ theme, $prev }) => css`
        width: 1rem;
        height: 1rem;

        ${$prev
            ? css`
                  transform: rotate(180deg);
                  margin-right: 0.25rem;
              `
            : css`
                  margin-left: 0.25rem;
              `}

        @media ${theme.breakpoints.medium.media} {
            width: 1.25rem;
            height: 1.25rem;
        }
    `}
`;
